import { NgModule, LOCALE_ID } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import locale from '@angular/common/locales/en';
import { BrowserModule, Title } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { NgxWebstorageModule } from 'ngx-webstorage';
import * as dayjs from 'dayjs';
import { NgbDateAdapter, NgbDateParserFormatter,  NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

import './config/dayjs';
import { SharedModule } from 'app/shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
// import { HomeModule } from './home/home.module';
import { EntityRoutingModule } from './entities/entity-routing.module';
// jhipster-needle-angular-add-module-import JHipster will add new module here
import { NgbDateDayjsAdapter } from './config/datepicker-adapter';
import { fontAwesomeIcons } from './config/font-awesome-icons';
import { httpInterceptorProviders } from 'app/core/interceptor/index';
import { translatePartialLoader, missingTranslationHandler } from './config/translation.config';
import { MainComponent } from './layouts/main/main.component';
import { NavbarComponent } from './layouts/navbar/navbar.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { PageRibbonComponent } from './layouts/profiles/page-ribbon.component';
import { ActiveMenuDirective } from './layouts/navbar/active-menu.directive';
import { ErrorComponent } from './layouts/error/error.component';
import { CommonFooterModule} from 'common-footer';
import { CommonHeaderModule} from 'common-header';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { EappregCriteriaComponent } from './component/eappreg-criteria/eappreg-criteria.component';
import { EappregBusinessQuestionsComponent } from './component/eappreg-business-questions/eappreg-business-questions.component';
import { DbErrorHandlerComponent } from './layouts/db-error-handler/db-error-handler.component';
import { ErrorPageComponent } from './layouts/error-page/error-page.component';
import { CommonDbhandlerModule } from 'common-dbhandler';
import { CommonErrorModule } from 'common-error';
import { CommonFiledbyModule} from 'common-filedby';
import { CommonFormelementsModule} from 'common-formelements';
import { Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import { DspQuestionsAnswersComponent } from './component/dsp-questions-answers/dsp-questions-answers.component';
import { EappregQuestionnaireComponent } from './component/eappreg-questionnaire/eappreg-questionnaire.component';
import { RemainingTextCounterPipe } from './shared/pipes/remaining-text-counter.pipe';
import { EappregTrcComponent } from './component/eappreg-trc/eappreg-trc.component';
import { EappregFuzzyMatchComponent } from './component/eappreg-fuzzy-match/eappreg-fuzzy-match.component';
import { EappregReceiptComponent } from './component/eappreg-receipt/eappreg-receipt.component';
import { EappregConfirmLetterComponent } from './component/eappreg-confirm-letter/eappreg-confirm-letter.component';
import { EappregPermitMainComponent } from './component/eappreg-permit-main/eappreg-permit-main.component';
import { EappregPermitQuestionsComponent } from './component/eappreg-permit-questions/eappreg-permit-questions.component';
import { EappregConfirmComponent } from './component/eappreg-confirm/eappreg-confirm.component';
import { SurveyEosLinkModule } from 'survey-eos-link';
import { PmtReceiptBasicModule } from 'pmt-receipt-basic';
import { EappregAppComponent } from './component/eappreg-app/eappreg-app.component';
import { NaicsSelectComponent } from './component/naics-select/naics-select.component';
import { CustomAdapter, CustomDateParserFormatter } from './shared/util/custom-dateformat';
import { EappregConfirmTextComponent } from './component/eappreg-confirm-text/eappreg-confirm-text.component';
import { DspQuestionsAnswersLevelComponent } from './component/dsp-questions-answers-level/dsp-questions-answers-level.component';
import { DspQuestionsAnswersFCLevelComponent } from './component/dsp-questions-answers-fclevel/dsp-questions-answers-fclevel.component';
import { WarningPageComponent } from './layouts/warning-page/warning-page.component';
import { EappregSelectsComponent } from './component/eappreg-selects/eappreg-selects.component';
import { EappregFastTrackComponent } from './component/eappreg-fasttrack/eappreg-fasttrack.component';
import { FasttrackDspQuestionsAnswersComponent } from './component/fasttrack-dsp-questions-answers/fasttrack-dsp-questions-answers.component';
import { EappregL288MeasureComponent } from './component/eappreg-L288-measure/eappreg-L288-measure.component';


@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    CommonFooterModule,
    CommonHeaderModule,
	CommonFiledbyModule,
    CommonFormelementsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    SurveyEosLinkModule,
    PmtReceiptBasicModule,
    // HomeModule,
    // jhipster-needle-angular-add-module JHipster will add new module here
    EntityRoutingModule,
    AppRoutingModule,
    CommonErrorModule,
    CommonDbhandlerModule,
    // Set this to true to enable service worker (PWA)
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: false }),
    HttpClientModule,
    NgxWebstorageModule.forRoot({ prefix: 'jhi', separator: '-' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translatePartialLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useFactory: missingTranslationHandler,
      },
    }),
  ],
  providers: [
    Title,
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    httpInterceptorProviders,
    DatePipe
  ],
  declarations: [MainComponent, 
    NavbarComponent, 
    ErrorComponent, 
    PageRibbonComponent, 
    ActiveMenuDirective, 
    FooterComponent,
    EappregCriteriaComponent,
	EappregSelectsComponent,
    EappregFastTrackComponent,
    EappregBusinessQuestionsComponent,
    DbErrorHandlerComponent,
    EappregFuzzyMatchComponent,
    EappregReceiptComponent,
    EappregConfirmLetterComponent,
    ErrorPageComponent,
    DspQuestionsAnswersComponent, 
    EappregQuestionnaireComponent, 
    RemainingTextCounterPipe,
    EappregTrcComponent,
    EappregPermitMainComponent,
    EappregPermitQuestionsComponent,
    EappregConfirmComponent,
	EappregAppComponent,
    NaicsSelectComponent,
    EappregConfirmTextComponent,
	DspQuestionsAnswersLevelComponent,
	DspQuestionsAnswersFCLevelComponent,
	WarningPageComponent,
	FasttrackDspQuestionsAnswersComponent, 
	EappregL288MeasureComponent,
	
  ],
  bootstrap: [MainComponent],
})
export class AppModule {
  constructor(iconLibrary: FaIconLibrary, dpConfig: NgbDatepickerConfig, translateService: TranslateService,private sessionTimeout: BnNgIdleService,private router:Router) {
    this.sessionTimeout.startWatching(1800).subscribe((res:any) => {
      if(res) {
        this.router.navigate(['error_page'])
      }
    })
    registerLocaleData(locale);
    iconLibrary.addIcons(...fontAwesomeIcons);
    dpConfig.minDate = { year: dayjs().subtract(100, 'year').year(), month: 1, day: 1 };
    translateService.setDefaultLang('en');
    translateService.use('en');
  }
}
